/**
 * Public link to a message in a Telegram channel or supergroup:
 * t.me/<username>/<id> for public chats, t.me/c/<internal id>/<id> for private ones.
 */
export function telegramPostLink(
  chat: { tgChatId: number | null; tgUsername: string | null },
  messageId: number,
): string | null {
  if (chat.tgUsername) return `https://t.me/${chat.tgUsername}/${messageId}`;
  if (chat.tgChatId === null) return null;
  const id = String(chat.tgChatId);
  if (!id.startsWith('-100')) return null;
  return `https://t.me/c/${id.slice(4)}/${messageId}`;
}

/** Query parameter of the welcome's phone button: the Mini App asks for the number on launch. */
export const PHONE_REQUEST_PARAM = 'request_phone';
